import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'antd';
import Translate from 'react-translate-component';

import { closeAllModals } from 'actions/modalActions';

@connect(null, { closeAllModals })
export default class ConfirmModal extends Component {
    componentDidMount() {
        const { remove, closeAllModals } = this.props;

        Modal.confirm({
            content: <Translate content="modal.close_all_modals" />,
            onOk: () => {
                closeAllModals();
            },
            onCancel: () => {
                remove();
            },
            okType: 'blue',
            okText: <Translate content="modal.close_yes" />,
            cancelText: <Translate content="modal.close_no" />,
            className: 'confirm-modal'
        });
    }

    render() {
        return null;
    }
}
